import ReGenerateApiKeyRequestModelBase from '../_generated/modelBases/re-generate-api-key-request-model-base';

export default class ReGenerateApiKeyRequestModel extends ReGenerateApiKeyRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
